import { render, staticRenderFns } from "./listCom.vue?vue&type=template&id=3212bddc&scoped=true"
import script from "./listCom.vue?vue&type=script&lang=js"
export * from "./listCom.vue?vue&type=script&lang=js"
import style0 from "./listCom.vue?vue&type=style&index=0&id=3212bddc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3212bddc",
  null
  
)

export default component.exports